// Validation helper functions with clear error messages

export const validateEmail = (email) => {
  if (!email) {
    return { valid: false, error: 'Email is required' }
  }
  if (email.length > 100) {
    return { valid: false, error: 'Email must be less than 100 characters' }
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) {
    return { valid: false, error: 'Please enter a valid email address' }
  }
  return { valid: true, error: '' }
}

export const validatePassword = (password) => {
  if (!password) {
    return { valid: false, error: 'Password is required' }
  }
  if (password.length < 6) {
    return { valid: false, error: 'Password must be at least 6 characters' }
  }
  if (password.includes(' ')) {
    return { valid: false, error: 'Password cannot contain spaces' }
  }
  return { valid: true, error: '' }
}

export const validateName = (name, fieldName = 'Name') => {
  if (!name || !name.trim()) {
    return { valid: false, error: `${fieldName} is required` }
  }
  if (name.trim().length < 2) {
    return { valid: false, error: `${fieldName} must be at least 2 characters` }
  }
  if (name.length > 50) {
    return { valid: false, error: `${fieldName} must be less than 50 characters` }
  }
  const nameRegex = /^[a-zA-Z0-9\s\-']{2,50}$/
  if (!nameRegex.test(name)) {
    return { valid: false, error: `${fieldName} can only contain letters, numbers, spaces, hyphens, and apostrophes` }
  }
  return { valid: true, error: '' }
}

export const validatePrice = (price) => {
  if (price === '' || price === null || price === undefined) {
    return { valid: false, error: 'Price is required' }
  }
  const priceNum = parseFloat(price)
  if (isNaN(priceNum)) {
    return { valid: false, error: 'Price must be a number' }
  }
  if (priceNum <= 0) {
    return { valid: false, error: 'Price must be greater than 0' }
  }
  if (priceNum > 99999) {
    return { valid: false, error: 'Price must be less than 99,999' }
  }
  return { valid: true, error: '' }
}

export const validateText = (text, fieldName = 'Text', minChars = 1, maxChars = 500) => {
  if (!text || !text.trim()) {
    return { valid: false, error: `${fieldName} is required` }
  }
  if (text.length < minChars) {
    return { valid: false, error: `${fieldName} must be at least ${minChars} characters` }
  }
  if (text.length > maxChars) {
    return { valid: false, error: `${fieldName} must be less than ${maxChars} characters` }
  }
  // Check for HTML/script content
  const htmlRegex = /<[^>]*>/g
  if (htmlRegex.test(text)) {
    return { valid: false, error: `${fieldName} cannot contain HTML` }
  }
  return { valid: true, error: '' }
}

export const validateDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return { valid: false, error: 'Both start and end dates are required' }
  }
  const start = new Date(startDate)
  const end = new Date(endDate)
  if (end <= start) {
    return { valid: false, error: 'End date must be after start date' }
  }
  return { valid: true, error: '' }
}

export const validatePhoneNumber = (phone) => {
  if (!phone) {
    return { valid: false, error: 'Phone number is required' }
  }
  const phoneRegex = /^[0-9\s\-\+\(\)]{10,}$/
  if (!phoneRegex.test(phone)) {
    return { valid: false, error: 'Please enter a valid phone number' }
  }
  return { valid: true, error: '' }
}

export const validateUrl = (url) => {
  if (!url) {
    return { valid: false, error: 'URL is required' }
  }
  try {
    new URL(url)
    return { valid: true, error: '' }
  } catch {
    return { valid: false, error: 'Please enter a valid URL' }
  }
}

// Validate entire form object
export const validateForm = (formData, validationRules) => {
  const errors = {}
  let isValid = true

  Object.keys(validationRules).forEach((field) => {
    const rule = validationRules[field]
    const result = rule.validator(formData[field])
    if (!result.valid) {
      errors[field] = result.error
      isValid = false
    }
  })

  return { isValid, errors }
}
